import useAxios from 'axios-hooks'

export const useMemberSpotlight = () => {
  // getMostRecentMemberSpotlight
  const [
    {
      data: dataMostRecentMemberSpotlight,
      loading: loadingMostRecentMemberSpotlight,
    },
    getRecent,
  ] = useAxios(
    { url: `member-spotlight/recent`, method: 'GET' },
    { manual: false }
  )

  // Other methods for member-spotlight route can be added here

  return {
    dataMostRecentMemberSpotlight,
    loadingMostRecentMemberSpotlight,
    getRecent,
  }
}
